<script lang="ts">
import {defineComponent, onMounted} from "vue";
import {useRouter} from "vue-router";
import {useAuthStore} from "@/composables/auth";
import {useTokensStore} from "@/composables/tokens";

export default defineComponent({
  setup() {
    const router = useRouter();
    const authStore = useAuthStore();
    const tokensStore = useTokensStore();

    onMounted(async () => {
      if (window.WebApp) {
        tokensStore.updateWebAppInitData(window.WebApp.initData);
        await authStore.authorize();

        if (!tokensStore.getToken()) {
          await router.push({name: 'unauthorized'});
          return;
        }

        await router.push({name: 'events'});
      } else {
        alert('Бот не поддерживается');
      }
    });
  }
})
</script>

<template>
  <div>
    <slot></slot>
  </div>
</template>